module.exports = __webpack_public_path__ + "media/application/images/icons/tick-white-76aa5d78d30fa2e74b7d84c2bd1b546d.svg";